class RecomendationCartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const swiper = new Swiper('.swiper-recomendation', {
      direction: 'horizontal',
      loop: true,
      pagination: {
        el: '.swiper-pagination-love-chocolate',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    const header = this.querySelector('.love-chocolate-recomendation-header');
    if (header) {
      header.addEventListener('click', () => this.toggle());
    }
  }

  toggle() {
    this.classList.toggle('recomendation-cart-drawer--open');
  }
}

customElements.define('recomendation-cart-drawer', RecomendationCartDrawer);


class LoveChocolateRecomendation {

  static spinner = false;

  static handleCartUpdated(items, sections) {
    const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    if (cart) {
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      cart.setActiveElement(document.activeElement);
      items.forEach(item => {
        cart.renderContents({
          ...item,
          sections: sections
        });
      });
      document.getElementById("CartDrawer-Form").style.display = "block";
    }
  }

  static addTesteSelectedVariant(variantId) {
    //adiciona aqui!
    if(!this.spinner) {
      // Encontrar o botão que foi clicado
      const button = document.getElementsByClassName(`button-` + variantId)[0];
      // Substituir o conteúdo do botão pelo loader
      button.innerHTML = '<span class="loader"></span>';
      console.log(button)
      }
    
    const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    const formData = {
      items: [{
        id: variantId,
        quantity: 1,
        properties: { _cart_recomendation: true }
      }],
      sections: "cart-drawer,cart-icon-bubble"
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(response => response.json())
      .then(data => {
        if (!data.status) {
          if (cart) {
            if (data.items && data.items.length > 0) {
              //deseparece aqui
              LoveChocolateRecomendation.handleCartUpdated(data.items, data.sections);
            }
          } else {
            window.location = window.routes.cart_url;
          }
        }
      })
      .catch(error => {
        //Aqui ele desaparece
        console.error('Error:', error);
        button.innerHTML = 'ADICIONAR';
      });
  }

  static addVariantBySelectMenu(productId) {
    const selectElement = document.getElementById("love-chocolate-cart-product-" + productId);
    const selectedValue = selectElement.value;
    const button = document.getElementsByClassName(`button-` + productId)[0];
    console.log(button)
    button.innerHTML = '<span class="loader"></span>';
    this.spinner = true;
    LoveChocolateRecomendation.addTesteSelectedVariant(selectedValue);
  }
}